import React from 'react'

const EnrollDocumentLink = ({ slice }) => {
    return (
        <section className="enroll-document-link">
            <div className="center-small">
                <div className="enroll-link-box">
                    <a href={slice.primary.document.url} target="_blank" rel="noreferrer" className="button-solid">{slice.primary.link_text.text}</a>
                </div>
            </div>
        </section>
    )
}

export default EnrollDocumentLink